/*
 * Moving the page to the first thing that is wrong.
 *
 * Several fields here are not the element the browser shows: select2 hides the
 * real <select>, CodeMirror hides the real <textarea>, and a radio group is a
 * question rather than one input. So each invalid field is resolved to whatever
 * is actually on screen before anything is scrolled to.
 */
var SCROLL_PADDING = 16;

/** The visible element standing in for a field the page has hidden. */
function visibleAnchorFor(element) {
    var $element = $(element);

    // select2 leaves the original select clipped out of sight next to its own
    // container, so that container is what the applicant is looking at.
    if ($element.hasClass('select2-hidden-accessible')) {
        var $select2 = $element.next('.select2-container');

        if ($select2.length) {
            return $select2;
        }
    }

    // CodeMirror replaces the textarea with its own editor inside this wrapper.
    var $code = $element.closest('.code-answer');

    if ($code.length) {
        return $code;
    }

    // One option out of a group is not the error - the question is.
    if ($element.is(':radio, :checkbox')) {
        var $group = $element.closest('.question-item, .form-check').first();

        if ($group.length) {
            return $group;
        }
    }

    return $element.is(':visible') ? $element : $element.closest(':visible').first();
}

/** Where to put the top of the viewport so `$anchor` clears the fixed header. */
function scrollTargetFor($anchor) {
    var header = $('.pc-header').filter(':visible');
    var offset = (header.length ? header.outerHeight() : 0) + SCROLL_PADDING;

    return Math.max(0, $anchor.offset().top - offset);
}

function scrollTo(top) {
    var reduceMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('scrollBehavior' in document.documentElement.style)) {
        window.scrollTo(0, top);

        return;
    }

    window.scrollTo({ top: top, behavior: 'smooth' });
}

/** Focus without the browser scrolling somewhere else of its own accord. */
function focusWithoutScrolling(element) {
    var $element = $(element);

    // The select2 container carries the focusable control; focusing the hidden
    // select behind it does nothing useful.
    if ($element.hasClass('select2-hidden-accessible')) {
        element = $element.next('.select2-container')
            .find('.select2-selection')
            .get(0) || element;
    }

    if (!element || typeof element.focus !== 'function') {
        return;
    }

    try {
        element.focus({ preventScroll: true });
    } catch (error) {
        // Older browsers ignore the options object; the scroll above already
        // put the field on screen, so a plain focus is close enough.
        element.focus();
    }
}

/**
 * The highest invalid field on the page. jQuery Validate lists errors in the
 * order it checked the fields, which is not top-to-bottom once a form mixes
 * radio groups with everything else, so position decides it.
 */
function highestError(errorList) {
    var highest = null;

    errorList.forEach(function (error) {
        var $anchor = visibleAnchorFor(error.element);

        if (!$anchor || !$anchor.length) {
            return;
        }

        var top = $anchor.offset().top;

        if (!highest || top < highest.top) {
            highest = { top: top, $anchor: $anchor, element: error.element };
        }
    });

    return highest;
}

function scrollToFirstError(validator) {
    if (!validator || !validator.errorList.length) {
        return;
    }

    var first = highestError(validator.errorList);

    if (!first) {
        return;
    }

    scrollTo(scrollTargetFor(first.$anchor));
    focusWithoutScrolling(first.element);
}

// Set jQuery Validation Defaults
jQuery.validator.setDefaults({
    errorElement: 'div',
    errorClass: 'invalid-feedback',
    // The handler below does the focusing, after the scroll: letting jQuery
    // Validate focus as well would fight it for the scroll position.
    focusInvalid: false,

    errorPlacement: function (error, element) {
        if (element.attr('type') === 'radio' || element.attr('type') === 'checkbox') {
            $(element).closest('div').parent().append(error);
        } else {
            $(element).closest('div').append(error);
        }
    },

    highlight: function (element) {
        if ($(element).hasClass('form-select')) {
            $(element).closest('.form-select').addClass('is-invalid').removeClass('is-valid');
        } else {
            $(element).closest('.form-control').addClass('is-invalid').removeClass('is-valid');
        }
    },

    unhighlight: function (element) {
        if ($(element).hasClass('form-select')) {
            $(element).closest('.form-select').removeClass('is-invalid').removeClass('is-valid');
        } else {
            $(element).closest('.form-control').removeClass('is-invalid').removeClass('is-valid');
        }
    },

    success: function (label, element) {
        $(element).removeClass('is-invalid');
        $(element).closest('.invalid-feedback').remove();
    },

    // A long form can fail on a question well below the fold, where nothing
    // about the rejected submit is visible. Go to it.
    invalidHandler: function (event, validator) {
        // The error messages are written after this fires, so the fields have
        // not moved anything yet; measure once they have.
        window.setTimeout(function () {
            scrollToFirstError(validator);
        }, 0);
    },

    submitHandler: function (form) {
        var $btn = $(form).find('button[type="submit"], input[type="submit"]');
        if ($btn.prop('disabled')) {
            return false;
        }
        $btn.prop('disabled', true).addClass('disabled');
        form.submit();
    }
});

/*
 * The same courtesy after a round trip: a submission the server rejected comes
 * back rendered at the top of the page with the errors somewhere below.
 */
$(function () {
    // After the other ready handlers, not among them: select2 is applied and
    // conditional questions are hidden in theirs, and both move the page.
    window.setTimeout(function () {
        var $first = $('.question-item-error, .is-invalid').filter(':visible').first();

        if (!$first.length) {
            return;
        }

        scrollTo(scrollTargetFor($first));
    }, 0);
});
